import React from 'react';
import { Card, Input, Button, Tooltip, Select, Table, Image } from 'antd';

import {
    RollbackOutlined,
    PlayCircleOutlined,
    SearchOutlined,
} from '@ant-design/icons';
import { getModelsColumns } from '@/features/datasets/components/ExploreDatasets/DefaultModelsColumns';
import { modelsData } from '@/features/datasets/components/ExploreDatasets/DefaultModelsData';
import { colors } from '@/shared/tokens/colors';

const tableProps = {
    bordered: false,
    loading: false,
    showHeader: false,
    showFooter: false,
    footer: undefined,
    showTitle: false,
    pagination: false,
}

export default function CheckModels(props) {
    const currentModelsData = modelsData.filter(d => props.currentOptions.some(item => item === d.model))
    return (
        <div>
            <Card hoverable style={{ marginBottom: "10px" }}>
                <div style={{ fontSize: '18px', fontWeight: 'bold' }}>Check Models:</div>
                <div style={{ display: 'flex', flexDirection: 'row', marginTop: "10px" }}>
                    <Select
                        mode="multiple"
                        allowClear
                        style={{
                            width: '100%',
                        }}
                        placeholder={<div><SearchOutlined /> Select Models</div>}
                        onChange={props.onModelsChange}
                        options={props.allOptions}
                        value={props.currentOptions}
                    />
                    <Tooltip title="reset" style={{ cursor: 'pointer' }}>
                        <Button
                            onClick={() => { props.setState({ showSpecificData: false, searchValue: "", showVocabResult: false, vocabValue: "" }) }}
                            style={{ color: colors.buttonsBlue, borderColor: colors.buttonsBlue, cursor: 'pointer', marginLeft: "10px" }}
                        >
                            <RollbackOutlined />
                        </Button></Tooltip>
                </div>

                <div style={{ display: 'flex', marginTop: "10px" }}>
                    <div style={{ marginRight: '10px', marginTop: "10px", marginBottom: "10px", display: 'flex', alignItems: 'end' }}>
                        <Button
                            style={{ color: colors.buttonsBlue, borderColor: colors.buttonsBlue, cursor: 'pointer' }}
                            onClick={() => props.moveToPlayground("Llama 3 8b - Instruct", "Mistral 7B - Instruct", "Mixtral 8X7B - Instruct")}
                        >
                            <PlayCircleOutlined /> Explore Prompts in Playground
                        </Button>
                    </div>
                    <div style={{ marginTop: "10px", marginBottom: "10px", display: 'flex', alignItems: 'end' }}>
                        <Button
                            style={{ color: colors.buttonsBlue, borderColor: colors.buttonsBlue, cursor: 'pointer' }}
                            onClick={() => { }}
                        >
                            Check Perplexity
                        </Button>
                    </div>
                    <div style={{ marginLeft: '10px', marginRight: '10px', marginTop: "10px", marginBottom: "10px", display: 'flex', alignItems: 'end' }}>
                        <Button
                            style={{ color: colors.buttonsBlue, borderColor: colors.buttonsBlue, cursor: 'pointer' }}
                            onClick={() => { }}
                        >
                            Calculate Loss
                        </Button>
                    </div>
                    <div style={{ marginRight: '5px', marginTop: "10px", marginBottom: "10px", flex: 1 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: "10px" }}>
                            <Input
                                value={props.vocabValue}
                                onChange={props.onVocabInputChange}
                                style={{ width: "100%", flex: 1, marginRight: "10px" }}
                                placeholder={"Enter a word to check if exists in vocab"} />
                            <div style={{ marginRight: "10px" }}><Tooltip title="check in vocab"><Button
                                onClick={props.onVocabClick}
                                style={{ color: colors.buttonsBlue, borderColor: colors.buttonsBlue, cursor: "pointer" }}
                            >
                                <PlayCircleOutlined />
                            </Button></Tooltip>
                            </div>
                            <Tooltip title="reset"><Button
                                onClick={props.onVocabReset}
                                style={{ color: colors.buttonsBlue, borderColor: colors.buttonsBlue, cursor: 'pointer' }}
                            >
                                <RollbackOutlined />
                            </Button></Tooltip>
                        </div>
                    </div>
                </div>
                {/* {getModelCards(props, get_models_data())} */}
                <div style={{ marginTop: "20px", display: "flex", flexDirection: "row" }}>
                    <div style={{ flex: "1.4" }}>
                        <Table
                            {...tableProps}
                            columns={getModelsColumns(props.vocabValue, props.goToTrain, props.currentDataset)}
                            dataSource={currentModelsData}
                            showHeader={true}
                        />
                    </div>
                    <div style={{ flex: "1", display: 'flex', justifyContent: 'right' }}>
                        <Image
                            src={currentModelsData.length > 3 ? './images/loss-4-models.jpg' : './images/loss-3-models.jpg'}
                        />
                    </div>
                </div>
            </Card>
        </div>
    );
};

